import { render } from "./SettlementComp.vue?vue&type=template&id=6d933194&scoped=true"
import script from "./SettlementComp.vue?vue&type=script&lang=js"
export * from "./SettlementComp.vue?vue&type=script&lang=js"

import "./SettlementComp.vue?vue&type=style&index=0&id=6d933194&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d933194"]])

export default __exports__